import React from "react";
import { connect } from "react-redux";

import {
  objectToArray,
  convertHMToSecs,
  removeItem,
  formatSecsToHrRange
} from "utils";
import { ReactComponent as EditScheduleIcon } from "assets/images/app_svg/backup/edit_schedule.svg";
import { ReactComponent as InformationIcon } from "assets/images/app_svg/information.svg";
import { TOOLTIPS } from "consts";
import Tooltip from "App/common/ui/Tooltip";

import ClickAwayListener from "@material-ui/core/ClickAwayListener";

function BackupPlanDaily(props) {
  const [dropDown, setDropDown] = React.useState(false);

  const toggleDropDown = () => setDropDown(prevState => !prevState);

  const hours = [];
  const minutes = [];
  if (props.startTime) {
    for (let i = props.startTime.hour.min; i <= props.startTime.hour.max; i++) {
      hours.push(
        <li
          value={i}
          onClick={() => {
            toggleScheduleStartTime(i, "hr");
            setDropDown(false);
          }}
          key={i}
        >
          {formatSecsToHrRange(i * 3600)}{" "}
        </li>
      );
    }
    // for (
    //   let i = props.startTime.minute.min;
    //   i <= props.startTime.minute.max;
    //   i = i + props.startTime.minute.int
    // ) {
    //   minutes.push(
    //     <option key={i} value={i}>
    //       {i > 9 ? "" + i : "0" + i}
    //     </option>
    //   );
    // }
  }

  function toggleScheduleStartTime(val, type) {
    let tempPlan = { ...props.planSettings };
    let time = 0;
    if (type === "hr") {
      time = convertHMToSecs(
        val,
        Math.trunc((tempPlan.scheduleInfo.startTime % 3600) / 60)
      );
    } else {
      time = convertHMToSecs(
        Math.trunc(tempPlan.scheduleInfo.startTime / 3600),
        val
      );
    }
    tempPlan.scheduleInfo.startTime = time;
    props.setPlanSettings(tempPlan);
  }

  return (
    <React.Fragment>
      <div className="sche_backup_item daily random_schedule">
        <div className="daily_wrap flex_align">
          <p>Start Time:</p>
          <div className="hours_mins_wrap flex_align">
            <ClickAwayListener onClickAway={() => setDropDown(false)}>
              <div
                className="hours_wrap flex_align"
                style={{ marginRight: "10px" }}
              >
                <div className={`customSelect ${dropDown ? "active" : ""}`}>
                  <span className="hrsValue">
                    {formatSecsToHrRange(
                      props.planSettings.scheduleInfo.startTime
                    )}
                  </span>
                  <ul className="customDropdwn">{hours}</ul>
                </div>
                <button className="edit_ico" onClick={() => toggleDropDown()}>
                  <Tooltip {...{ title: "Edit", position: "top" }}>
                    <EditScheduleIcon />
                  </Tooltip>
                </button>
              </div>
            </ClickAwayListener>
            <Tooltip {...TOOLTIPS.backupSettings.schedule.editInfo}>
              <span className="slot_icon">
                <InformationIcon />
              </span>
            </Tooltip>
          </div>
        </div>
        <div className="days_wrap">
          <div className="days_layer" />
          <div className="days_block  mon__day">Mon</div>
          <div className="days_block  tue__day">Tue</div>
          <div className="days_block  wed__day">Wed</div>
          <div className="days_block  thu__day">Thu</div>
          <div className="days_block  fri__day">Fri</div>
          <div className="days_block  sat__day">Sat</div>
          <div className="days_block  sun__day">Sun</div>
        </div>
      </div>
    </React.Fragment>
  );
}

function mapStateToProps(state) {
  return {
    startTime: state.backupSettings.scheduleInfo.startTime
  };
}

export default connect(mapStateToProps)(BackupPlanDaily);
